import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import { StatesQuery } from '@components/states'
import FeaturedCourse from '@components/featured-course'
import SearchCourse from '@components/search-course'
import TopStories from '@components/group-top-stories'
import useStyles from '@components/atoms/styles'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import { JsonLd } from '@components/atoms'
import { Hero } from '../courses.styles'

const GolfCoursesPage = (props) => {
  const {
    heroHeadline,
    heroImage,
    destinationsHeadline,
    metaTitle,
    metaDescription,
    metaImage,
    featuredStory,
    storiesCollection,
    featuredCourseEyebrow,
    featuredCourseId,
    featuredCourseImage,
    ssrStatesData,
  } = props
  const atoms = useStyles()

  return (
    <div>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        description={metaDescription}
        canonical={`${defaults.baseUrl}play`}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: `${defaults.baseUrl}play`,
          images: [{ url: (metaImage && metaImage.url) || (heroImage && heroImage.url) }],
        }}
      />
      <JsonLd {...{
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': 'https://www.pga.com/play',
            name: 'Golf Courses',
          },
        }],
      }}
      />
      <Hero image={heroImage && heroImage.url} className={atoms.darkenOverlay}>
        <Typography variant="h2" align="center" data-testid="play-headline">{heroHeadline}</Typography>
        <Box mt={6} px={2} width={['100%', '100%', 680]}>
          <SearchCourse withDropdown withTabs ssrStatesData={ssrStatesData} />
        </Box>
      </Hero>

      <Box py={[4, 6, 10]} bgcolor="white">
        <Container data-testid="destinations">
          <Box mb={[4, 4, 6]}>
            <Typography variant="h4" align="center">{destinationsHeadline || 'Top Stories'}</Typography>
          </Box>
          <TopStories
            leadStory={featuredStory}
            topStories={storiesCollection.items}
            bordered
          />
        </Container>
      </Box>

      {featuredCourseId && (
        <FeaturedCourse
          id={featuredCourseId}
          eyebrow={featuredCourseEyebrow}
          background={featuredCourseImage}
        />
      )}

      <StatesQuery ssrData={ssrStatesData} />
    </div>
  )
}

GolfCoursesPage.propTypes = {
  heroHeadline: PropTypes.string,
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  heroImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  destinationsHeadline: PropTypes.string,
  featuredStory: PropTypes.shape({}),
  storiesCollection: PropTypes.shape({
    items: PropTypes.array,
  }),
  featuredCourseEyebrow: PropTypes.string,
  featuredCourseId: PropTypes.string,
  featuredCourseImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  ssrStatesData: PropTypes.array,
}

export default GolfCoursesPage
